module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDQ5NGIyZGQyMjA1OTE0OGY0MDIxYjZmODdhZWMxY2UucG5nIjs="